import { BottleCap } from '../app/BottleCap';
import { CantonShield } from '../app/CantonShield';
import { useI18n } from '../../i18n';
import type { LeaderboardEntry } from '../../lib/boards';

/** One leaderboard row. Top-3 ranks get medal tinting; the caller's row glows.
 *  Names link to the player's public profile (own row → /profile). */
export function LeaderRow({ e }: { e: LeaderboardEntry }) {
  const { localePath } = useI18n();
  const medal = e.rank <= 3 ? ` lr--m${e.rank}` : '';
  const href = e.me ? localePath('/profile') : localePath(`/u/${e.userId}`);
  return (
    <a class={`lr lr--link${e.me ? ' lr--me' : ''}${medal}`} href={href}>
      <span class="lr__rank">{e.rank}</span>
      {e.avatarUrl ? (
        <img class="lr__avatar" src={e.avatarUrl} alt="" />
      ) : (
        <BottleCap code={e.cap} size={30} />
      )}
      <span class="lr__name">
        {e.nickname}
        <CantonShield code={e.canton} size={14} />
      </span>
      <span class="lr__picks">{e.picks}</span>
      <span class="lr__pts">{e.pts}</span>
    </a>
  );
}
